module.exports = __webpack_public_path__ + "img/set_invite_code_img.305834de.png";